import React from 'react';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const GoToWorkboard = ({ workboardURL }: { workboardURL: string }) => {
  const navigate = useNavigate();

  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={() => {
        navigate(workboardURL);
      }}
      startIcon={<ArrowBackIcon />}>
      Go to Workboard
    </Button>
  );
};

export default GoToWorkboard;
